import useTranslate from "@hooks/use_translate"
import { Alert, AlertTitle, Button, LinearProgress, Stack } from "@mui/material"
import { MigrationRow, formatElapsed, pickText } from "./migration.models"

type Props = {
  rows: MigrationRow[]
  now: number
  onOpen: (row: MigrationRow) => void
}

export default function ActiveRunBanner({ rows, now, onOpen }: Props) {
  const { translate, currentLanguage } = useTranslate()
  if (rows.length === 0) return null

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      {rows.map((row) => {
        const startedAt = row.lastRun?.startedAt ?? ""
        return (
          <Alert
            key={row.spec.type}
            severity="info"
            action={
              <Button
                color="inherit"
                size="small"
                disabled={!row.state}
                onClick={() => onOpen(row)}
              >
                {translate("migration_details_button")}
              </Button>
            }
          >
            <AlertTitle>
              {translate("migration_active_run_banner", {
                title: pickText(row.spec.title, currentLanguage),
                elapsed: formatElapsed(now - new Date(startedAt).getTime()),
                started: new Date(startedAt).toLocaleString()
              })}
            </AlertTitle>
            {translate("migration_active_run_note")}
            <LinearProgress sx={{ mt: 1 }} />
          </Alert>
        )
      })}
    </Stack>
  )
}
